// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';
import { Progress } from '../../../types/Model';

export interface UpdateIltCourseProgressRequestPayload {
  id: number;
  progress: Progress;
  onSuccess: () => void;
}
export interface UpdateIltCourseProgressSuccessPayload {
  id: number;
  progress: Progress[];
}

export interface UpdateIltCourseProgressFailPayload {
  error: Error;
}

const updateIltCourseProgressActions = createAsyncAction(
  'elearning/UPDATE_ILT_COURSE_PROGRESS_REQUEST',
  'elearning/UPDATE_ILT_COURSE_PROGRESS_SUCCESS',
  'elearning/UPDATE_ILT_COURSE_PROGRESS_FAIL'
)<UpdateIltCourseProgressRequestPayload, UpdateIltCourseProgressSuccessPayload, UpdateIltCourseProgressFailPayload>();

export { updateIltCourseProgressActions as default };
